module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fc-Gb-Hc-Ia-Gb.97182294.png";